import React from 'react';

// Store print content in localStorage
const preseervePrintContent = (docData) => {
    localStorage.removeItem('printContent');
    localStorage.setItem("printContent", JSON.stringify(docData));
};

// Generate and open the print preview window
const generatePrintPreview = (printTarget, docTitle, contentTitle) => {
    if (window.alimPrintWindow) {
        window.alimPrintWindow.close();
    }

    const prntScript = document.createElement('script');
    prntScript.src = '/js/printDiv.js';

    const htmlDoc = `
        <html>
            <head>
                <title>${docTitle}</title>
                <link rel="icon" type="image/x-icon" href="/images/favicon.ico">
                <link rel="stylesheet" href="/css/style.css" />
                <link rel="stylesheet" href="/css/printThis.css" />
            </head>
            <body>
                <div class="w-full flex mb-3">
                    <h1 class="ml-3 mb-8">${contentTitle}</h1>
                </div>
                ${printTarget}
                <div class="w-full flex justify-center">
                    <button id="prntBtn" class="!text-white bg-deep-red rounded px-5 py-2 mx-auto fixed bottom-2" onclick="startPrintDiv()">Save</button>
                </div>
                ${prntScript.outerHTML}
                <div class="divFooter">
                    <p class="opacity-50">All rights reserved to Alim.org</p>
                </div>
            </body>
        </html>
    `;

    preseervePrintContent(htmlDoc);

    const alimPrintWindow = window.open('', 'Print-Window');
    alimPrintWindow.document.open();
    alimPrintWindow.document.write(htmlDoc);
    alimPrintWindow.document.close();

    window.alimPrintWindow = alimPrintWindow;
};

// Handle the print logic based on the selector (ID or class)
const handlePrintClick = (elemToCapture, pageTitle) => {
    const docTitle = `Export: ${pageTitle}`;
    let printTarget = '';

    if (elemToCapture.startsWith('#')) {
        const elem = document.getElementById(elemToCapture.slice(1));
        printTarget = elem ? elem.outerHTML : '<p>Element not found</p>';
    } else if (elemToCapture.startsWith('.')) {
        const elems = document.querySelectorAll(elemToCapture);
        elems.forEach(el => {
            printTarget += el.outerHTML;
        });
        if (!printTarget) printTarget = '<p>Element(s) not found</p>';
    }

    generatePrintPreview(printTarget, docTitle, pageTitle);
};

const ExportAlimContent = ({ elemToCapture, pageType, pageTitle }) => {
    return (
        <>
            {
                pageType === "hadith" &&
                <button
                    className="export-btn"
                    title="Export or print"
                    onClick={() => handlePrintClick(elemToCapture, pageTitle)}
                >
                    <div className="print-img-elem w-[22px] h-[22px]"></div>
                    <span className="ml-2">Print</span>
                </button>
            }
        </>
    );
};

export default ExportAlimContent;